import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AnimatePresence } from 'framer-motion';

import Header from './components/Header';
import FloatingActions from './components/FloatingActions';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Faq from './pages/Faq';
import NotFound from './pages/NotFound';
import FreelancerInVirar from './pages/FreelancerInVirar';
import LocationLandingPage, {
  locationPages,
} from './pages/LocationLandingPage';
import WebsiteDesignerVirarWest from './pages/WebsiteDesignerVirarWest';



import './pages/Home.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function AppRoutes() {
  const location = useLocation();
  const hideHeaderOnHome = location.pathname === '/';

  return (
    <>
      <ScrollToTop />

      {!hideHeaderOnHome && <Header />}

      <main>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />

            <Route path="/about" element={<About />} />
            <Route path="/about-us" element={<About />} />

            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />

            <Route
              path="/freelancer-in-virar"
              element={<FreelancerInVirar />}
            />

            <Route
              path="/website-designer-virar-west"
              element={<WebsiteDesignerVirarWest />}
            />

            {Object.keys(locationPages).map((slug) => (
              <Route
                key={slug}
                path={`/${slug}`}
                element={<LocationLandingPage slug={slug} />}
              />
            ))}

            <Route path="/faq" element={<Faq />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/contact-us" element={<Contact />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </AnimatePresence>
      </main>

      <FloatingActions />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  );
}
